export default __webpack_public_path__ + "static/triangle_b.4708fc7b6068a9a5cff13e221eb81b47.svg";